import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Accordion from '../../../components/common/Accordion';
import AccordionFAQHeader from '../../../components/common/Accordion/AccordionFAQHeader';
import { getSupportPage } from '../../../modules/content/selectors';
import contentBackup from '../../../../resources/supportBackup.json';

/* eslint-disable react/no-danger */
export const Support = ({ contentStackContent }) => {
  let content;
  if (contentStackContent) {
    content = contentStackContent;
  } else {
    content = contentBackup;
  }
  return (
    <div className="support">
      <div className="container--fixed">
        <React.Fragment key={content.customerRelationsTeam.title}>
          <h2 className="support__header">{content.customerRelationsTeam.title}</h2>
          <div
            className="support__text-section"
            dangerouslySetInnerHTML={{ __html: content.customerRelationsTeam.text }}
          />
        </React.Fragment>
        <h2 className="support__header">{content.faqs.title}</h2>
        {content.faqs.item.map(section => (
          <React.Fragment key={section.title}>
            <Accordion
              header={AccordionFAQHeader}
              headerText={section.title}
              key={`faq-${section.title}`}
              className="support__accordion"
            >
              <div className="support__answer" dangerouslySetInnerHTML={{ __html: section.text }} />
            </Accordion>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
/* eslint-enable react/no-danger */

Support.propTypes = {
  contentStackContent: PropTypes.object
};

const mapStateToProps = (state) => ({
  contentStackContent: getSupportPage(state)
});

export default connect(mapStateToProps)(Support);
